module.exports = __webpack_public_path__ + "static/media/SUSHI-ETH SLP-logo.3181bca9.png";